<template>
  <div class="leftWraper box">
      <div class="box lWraper">
        <div class="NavCom box pointer" :class="{'active':$route.name=='home'}" @click="go('/home')" style="border-top-right-radius: 30px;">
            <img src="static/image/home1.png" alt="" class="img imgcom" style="float: right;width: 80%;height: auto;">
            <img src="static/image/homeActive1.png" alt="" class="img imgactive" style="float: right;width: 80%;height: auto;">
            <!-- <p class="navTitle">首页</p> -->
        </div>
       <div class="NavCom box pointer" :class="{'active':$route.name=='student'}" @click="go('/student')">
         <img src="static/image/student1.png" alt="" class="img imgcom" style="float: right;width: 80%;height: auto;">
         <img src="static/image/studentActive1.png" alt="" class="img imgactive" style="float: right;width: 80%;height: auto;">
           <!-- <img src="static/image/student.png" alt="" class="img imgcom">
           <img src="static/image/student_active.png" alt="" class="img imgactive">
           <p class="navTitle">学生管理</p> -->
       </div>
        <div class="NavCom box pointer" :class="{'active':$route.name=='test'}" @click="go('/test')">
          <img src="static/image/test1.png" alt="" class="img imgcom" style="float: right;width: 80%;height: auto;">
          <img src="static/image/testActive1.png" alt="" class="img imgactive" style="float: right;width: 80%;height: auto;">
            <!-- <img src="static/image/project.png" alt="" class="img imgcom">
            <img src="static/image/project_active.png" alt="" class="img imgactive">
            <p class="navTitle">测评管理</p> -->
        </div>
        <!-- <div class="NavCom box pointer" :class="{'active':$route.name=='project'}" @click="go('/project')">
          <img src="static/image/project1.png" alt="" class="img imgcom" style="float: right;width: 80%;height: auto;">
          <img src="static/image/projectActive1.png" alt="" class="img imgactive" style="float: right;width: 80%;height: auto;">
        </div> -->

        <!-- <div class="NavCom box pointer" :class="{'active':$route.name=='user'}" @click="go('/user')">
            <img src="static/image/user.png" alt="" class="img imgcom">
            <img src="static/image/user_active.png" alt="" class="img imgactive">
            <p class="navTitle">用户管理</p>
        </div> -->
        <div class="NavCom box pointer" :class="{'active':$route.name=='setting'}" @click="go('/setting/set')">
          <img src="static/image/set1.png" alt="" class="img imgcom" style="float: right;width: 80%;height: auto;">
          <img src="static/image/setActive1.png" alt="" class="img imgactive" style="float: right;width: 80%;height: auto;">
            <!-- <img src="static/image/setting.png" alt="" class="img imgcom">
            <img src="static/image/setting_active.png" alt="" class="img imgactive">
            <p class="navTitle">系统设置</p> -->
        </div>
      </div>
      <div style="position: absolute;bottom: 10px;line-height: 30px;font-size: 14px;color: #fff;width:100%">
        <p class="tx-center">景云智心出品</p>
        <p class="tx-center">基础版V1.0</p>
      </div>
  </div>
</template>

<script>
  export default {
  	props: ['pop', 'parent'],
  	data() {
  		return {
  			data:true
  		}
  	},
  	created() {

  	},
  	computed: {

  	},
  	mounted() {

  	},
    methods:{
      go(path){
        this.$router.push({
        	path: path
        });
      }
    }
  }
</script>

<style scoped>
  .leftWraper{
    width: 180px;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    padding-top: 70px;
    z-index: 1;
    /* background: #2760A8; */
  }
  .img{
    width: 24px;
    height: 24px;
    display: block;
    margin: 0 auto;
    margin-bottom: 15px;
  }
  .NavCom{
    padding-top: 60px;
    /* height: 108px; */
    color:#D6EAFF;
  }
  .NavCom .imgcom{
    display: block;
  }
  .NavCom .imgactive{
    display: none;
  }
  .NavCom.active .imgcom{
    display: none;
  }
  .NavCom.active .navTitle{
    color: #fff;
  }
  .NavCom.active .imgactive{
    display: block;
  }
  .NavCom.active{
    /* background: #3a88fb!important; */
  }
  .NavCom:hover{
    /* background: #224d71; */
  }
  .navTitle{
    font-size: 14px;
    text-align: center;
  }
  .lWraper{
    background-color: #2760A8;
    border-top-right-radius: 30px;
    height: calc(100vh - 70px);
  }
</style>



// WEBPACK FOOTER //
// src/components/leftBar.vue